import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RequestCallbackSection from "./component";
import { createCallbackRequest, leadpost } from "./action";
import { withRouter } from "react-router";
import withLoginSignupPopup from "../../shared/with-login-signup";

const mapStateToProps = ({
    user: { mobile, isLoggedIn, secureToken }

}) => ({
    mobile,
    isLoggedIn,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    leadConnect: leadpost,
    createCallbackRequestConnect: createCallbackRequest
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLoginSignupPopup(RequestCallbackSection)));
